import {Button} from 'components/ui';
import {useState} from 'react';
import styles from './Uploader.module.scss';

export interface UploaderProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  register?: (
    ref: HTMLInputElement | null,
    options?: {required?: boolean},
  ) => void;
  maxNumberOfFiles?: number;
  maxFileSize?: string;
  localSelectedFiles: File[];
  setLocalSelectedFiles: (data: File[]) => void;
}

function Uploader({
  register,
  maxNumberOfFiles,
  maxFileSize,
  localSelectedFiles,
  setLocalSelectedFiles,
  ...inputProps
}: UploaderProps): JSX.Element {
  const [uploadInputRef, setUploadInputRef] =
    useState<HTMLInputElement | null>(null);
  const [dragging, setDragging] = useState<boolean>(false);

  function handleButtonClick() {
    if (uploadInputRef) {
      uploadInputRef.click();
    }
  }

  function handleFileInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.files) {
      const filesArray = Array.from(event.target.files);
      setLocalSelectedFiles([...localSelectedFiles, ...filesArray]);
    }
  }

  function handleDrop(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    if (event?.dataTransfer?.files) {
      const filesArray = Array.from(event.dataTransfer.files);
      setLocalSelectedFiles([...localSelectedFiles, ...filesArray]);
    }
    setDragging(false);
  }

  function updateDragState(
    event: React.DragEvent<HTMLDivElement>,
    state: boolean,
  ) {
    event.preventDefault();
    setDragging(state);
  }

  return (
    <div
      onDrop={handleDrop}
      onDragOver={(event) => updateDragState(event, true)}
      onDragLeave={(event) => updateDragState(event, false)}
      className={`${styles.dropzone} ${dragging ? styles.dragging : ''}`}
      data-testid="uploader"
    >
      <div className={styles.uploadContent}>
        <Button
          variant="secondary"
          text={dragging ? 'Soltar arquivos' : 'Adicionar fotos'}
          leftIcon={{
            icon: ['fad', 'cloud-arrow-up'],
            color: 'goldenrod',
          }}
          onClick={handleButtonClick}
          textColor="black"
        />

        <span className={styles.uploadAttributes}>
          Limite de upload: {maxFileSize}
          <br />
          Máximo de arquivos: {maxNumberOfFiles}
        </span>
      </div>

      <input
        data-testid="uploaderInput"
        style={{display: 'none'}}
        type="file"
        multiple
        onChange={handleFileInputChange}
        ref={(event) => {
          if (event) {
            setUploadInputRef(event);
            register?.(event, {required: true});
          }
        }}
        {...(inputProps || {})}
      />

      <div
        className={`${styles.uploadContent} ${styles.hideMobileUploadContent}`}
      >
        <strong>ou arraste e solte os arquivos aqui</strong>
        <span>Apenas arquivos {inputProps.accept}</span>
      </div>
    </div>
  );
}

export default Uploader;
